<template>
  <div class="table-operations">
    <div class="left-buttons">
      <!-- Add Button -->
      <el-button
        v-if="showAdd"
        type="primary"
        plain
        icon="el-icon-plus"
        size="mini"
        :disabled="disableAdd"
        v-hasPermi="addPermi"
        @click="$emit('add')"
      >{{ addText }}</el-button>

      <!-- Edit Button -->
      <el-button
        v-if="showEdit"
        type="success"
        plain
        icon="el-icon-edit"
        size="mini"
        :disabled="disableEdit"
        v-hasPermi="editPermi"
        @click="$emit('edit')"
      >{{ editText }}</el-button>

      <!-- Delete Button -->
      <el-button
        v-if="showDelete"
        type="danger"
        plain
        icon="el-icon-delete"
        size="mini"
        :disabled="disableDelete"
        v-hasPermi="deletePermi"
        @click="$emit('delete')"
      >{{ deleteText }}</el-button>

      <!-- Export Button -->
      <el-button
        v-if="showExport"
        type="warning"
        plain
        icon="el-icon-download"
        size="mini"
        :disabled="disableExport"
        v-hasPermi="exportPermi"
        @click="$emit('export')"
      >{{ exportText }}</el-button>

      <!-- Custom Buttons (Slot) -->
      <slot></slot>
    </div>
    
    <div class="right-tools">
      <slot name="right-toolbar"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableOperations",
  props: {
    // Add Configuration
    showAdd: { type: Boolean, default: true },
    disableAdd: { type: Boolean, default: false },
    addText: { type: String, default: '新增' },
    addPermi: { type: Array, default: () => [] },

    // Edit Configuration
    showEdit: { type: Boolean, default: false }, // Default false as often inline
    disableEdit: { type: Boolean, default: true },
    editText: { type: String, default: '修改' },
    editPermi: { type: Array, default: () => [] },

    // Delete Configuration
    showDelete: { type: Boolean, default: true },
    disableDelete: { type: Boolean, default: true },
    deleteText: { type: String, default: '删除' },
    deletePermi: { type: Array, default: () => [] },

    // Export Configuration
    showExport: { type: Boolean, default: false },
    disableExport: { type: Boolean, default: false },
    exportText: { type: String, default: '导出' },
    exportPermi: { type: Array, default: () => [] },
  }
};
</script>

<style scoped>
.table-operations {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px; /* Consistent spacing */
}

.left-buttons {
  display: flex;
  align-items: center;
  gap: 10px; /* Space between buttons */
}

.right-tools {
  display: flex;
  align-items: center;
}
</style>
